import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class FejezetEditDto extends IdentifiableDto {
	constructor() {
		super();

		this.nev = null;
		this.sorszam = null;
		this.feladatCsoport = null;
		this.userGroup = null;
	}

	setup(props) {
		super.setup(props);

		this.nev = props.nev;
		this.sorszam = props.sorszam;
		this.feladatCsoport = props.feladatCsoport;
		this.userGroup = props.userGroup;

		return this;
	}
}

export default FejezetEditDto;
